import {
    OVReportMetadata
} from "./ReportViewSchema.js";
import {HEAVY_PACKAGE, KG_TO_POUND, isPackageNonConveyable, convertWeightToKilograms, convertLengthToCm} from "./Util.js";
import {fetchBatchPackageSummary} from "./BatchPackageSummary.js";
export const calculateOVStagedReportMetadata = async (totalStagedPackages) => {
    if (totalStagedPackages.length === 0) {
        return new OVReportMetadata(0, 0, 0, 0, 0, 0, 0);
    }
    const stagedTrackingIds = totalStagedPackages.map(
        (stagedPackage) => stagedPackage.trackingId
    );

    let stagedOVPackageDetails = await fetchBatchPackageSummary(
        stagedTrackingIds
    );
    let result = stagedOVPackageDetails.reduce(
        (acc, curr) => {
            const nonConveyablePackage = isPackageNonConveyable(curr);
            const currPackageWeight = convertWeightToKilograms(
                curr.packageWeight.value,
                curr.packageWeight.unit
            );
            const currPackageTotalDimension =
                convertLengthToCm(curr.packageLength.value, curr.packageLength.unit) +
                convertLengthToCm(curr.packageWidth.value, curr.packageWidth.unit) +
                convertLengthToCm(curr.packageHeight.value, curr.packageHeight.unit)

            const isHighestDimensionPackageTillNow = currPackageTotalDimension > acc.heighestDimension ? true : false

            return {
                max: Math.max(acc.max, currPackageWeight),
                sum: acc.sum + currPackageWeight,
                count: acc.count + 1,
                nonConveyableCount: acc.nonConveyableCount + (nonConveyablePackage ? 1 : 0),
                heaviestNonConveyable: (nonConveyablePackage ? Math.max(acc.heaviestNonConveyable, currPackageWeight) : acc.heaviestNonConveyable),
                totalNonConveyableWeight: acc.totalNonConveyableWeight + (nonConveyablePackage ? currPackageWeight : 0),
                heavyCount: acc.heavyCount + (currPackageWeight * KG_TO_POUND > HEAVY_PACKAGE ? 1 : 0),
                heighestDimension: (isHighestDimensionPackageTillNow ? currPackageTotalDimension : acc.heighestDimension),
                highestDimensionPackageWeight: (isHighestDimensionPackageTillNow ? currPackageWeight : acc.highestDimensionPackageWeight)
            };
        },
        {max: -Infinity, sum: 0, count: 0, nonConveyableCount: 0, heaviestNonConveyable: 0, totalNonConveyableWeight: 0, heavyCount: 0, heighestDimension: 0, highestDimensionPackageWeight: 0}
    );
    return new OVReportMetadata(
        result.count,
        result.max,
        result.sum / result.count,
        result.sum,
        result.nonConveyableCount,
        result.heaviestNonConveyable,
        result.totalNonConveyableWeight,
        result.heavyCount,
        result.heighestDimension,
        result.highestDimensionPackageWeight
    );
};

export const calculateOVPickedReportMetadata = async (totalPickedPackages) => {
    if (totalPickedPackages.length === 0) {
        return new OVReportMetadata(0, 0, 0, 0, 0, 0, 0);
    }
    const pickedTrackingIds = totalPickedPackages.map(
        (pickedPackage) => pickedPackage.trackingId
    );

    let pickedPackageDetails = await fetchBatchPackageSummary(
        pickedTrackingIds
    );
    let result = pickedPackageDetails.reduce(
        (acc, curr) => {
            const nonConveyablePackage = isPackageNonConveyable(curr);
            const currPackageWeight = convertWeightToKilograms(
                curr.packageWeight.value,
                curr.packageWeight.unit
            );
            const currPackageTotalDimension =
                convertLengthToCm(curr.packageLength.value, curr.packageLength.unit) +
                convertLengthToCm(curr.packageWidth.value, curr.packageWidth.unit) +
                convertLengthToCm(curr.packageHeight.value, curr.packageHeight.unit)

            const isHighestDimensionPackageTillNow = currPackageTotalDimension > acc.heighestDimension ? true : false

            return {
                max: Math.max(acc.max, currPackageWeight),
                sum: acc.sum + currPackageWeight,
                count: acc.count + 1,
                nonConveyableCount: acc.nonConveyableCount + (nonConveyablePackage ? 1 : 0),
                heaviestNonConveyable: (nonConveyablePackage ? Math.max(acc.heaviestNonConveyable, currPackageWeight) : acc.heaviestNonConveyable),
                totalNonConveyableWeight: acc.totalNonConveyableWeight + (nonConveyablePackage ? currPackageWeight : 0),
                heavyCount: acc.heavyCount + (currPackageWeight * KG_TO_POUND > HEAVY_PACKAGE ? 1 : 0),
                heighestDimension: (isHighestDimensionPackageTillNow ? currPackageTotalDimension : acc.heighestDimension),
                highestDimensionPackageWeight: (isHighestDimensionPackageTillNow ? currPackageWeight : acc.highestDimensionPackageWeight)
            };
        },
        {max: -Infinity, sum: 0, count: 0, nonConveyableCount: 0, heaviestNonConveyable: 0, totalNonConveyableWeight: 0, heavyCount: 0, heighestDimension: 0, highestDimensionPackageWeight: 0}
    );
    return new OVReportMetadata(
        result.count,
        result.max,
        result.sum / result.count,
        result.sum,
        result.nonConveyableCount,
        result.heaviestNonConveyable,
        result.totalNonConveyableWeight,
        result.heavyCount,
        result.heighestDimension,
        result.highestDimensionPackageWeight
    );
};


export const calculateOVStowReportMetadata = async (totalOVStowedPackages) => {
    if (totalOVStowedPackages.length === 0) {
        return new OVReportMetadata(0, 0, 0, 0, 0, 0, 0);
    }
    const stowedOVTrackingIds = totalOVStowedPackages.map(
        (stowedPackage) => stowedPackage.trackingId
    );

    let stowedOVPackageDetails = await fetchBatchPackageSummary(
        stowedOVTrackingIds
    );
    let result = stowedOVPackageDetails.reduce(
        (acc, curr) => {
            const nonConveyablePackage = isPackageNonConveyable(curr);
            const currPackageWeight = convertWeightToKilograms(
                curr.packageWeight.value,
                curr.packageWeight.unit
            );
            const currPackageTotalDimension =
                convertLengthToCm(curr.packageLength.value, curr.packageLength.unit) +
                convertLengthToCm(curr.packageWidth.value, curr.packageWidth.unit) +
                convertLengthToCm(curr.packageHeight.value, curr.packageHeight.unit)

            const isHighestDimensionPackageTillNow = currPackageTotalDimension > acc.heighestDimension ? true : false
            return {
                max: Math.max(acc.max, currPackageWeight),
                sum: acc.sum + currPackageWeight,
                count: acc.count + 1,
                nonConveyableCount: acc.nonConveyableCount + (nonConveyablePackage ? 1 : 0),
                heaviestNonConveyable: (nonConveyablePackage ? Math.max(acc.heaviestNonConveyable, currPackageWeight) : acc.heaviestNonConveyable),
                totalNonConveyableWeight: acc.totalNonConveyableWeight + (nonConveyablePackage ? currPackageWeight : 0),
                heavyCount: acc.heavyCount + (currPackageWeight * KG_TO_POUND > HEAVY_PACKAGE ? 1 : 0),
                heighestDimension: (isHighestDimensionPackageTillNow ? currPackageTotalDimension : acc.heighestDimension),
                highestDimensionPackageWeight: (isHighestDimensionPackageTillNow ? currPackageWeight : acc.highestDimensionPackageWeight)
            };
        },
        {max: -Infinity, sum: 0, count: 0, nonConveyableCount: 0, heaviestNonConveyable: 0, totalNonConveyableWeight: 0, heavyCount: 0, heighestDimension: 0, highestDimensionPackageWeight: 0}
    );
    return new OVReportMetadata(
        result.count,
        result.max,
        result.sum / result.count,
        result.sum,
        result.nonConveyableCount,
        result.heaviestNonConveyable,
        result.totalNonConveyableWeight,
        result.heavyCount,
        result.heighestDimension,
        result.highestDimensionPackageWeight
    );
};




// WEBPACK FOOTER //
// ./src/components/detailPages/associateDetails/safetyReport/OVReport.js